import React, {useCallback} from 'react';
import {useTheme} from '../../../../../../shared/theme';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Screens} from '../../../../../../shared/routing';
import {TouchableOpacity, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {images} from '../../../../../../assets/icons';
import {Text} from '../../../../../../shared/components/text';
import Screen from '../../../../../../shared/components/screen';
import {EsiaRegCardFormScreen} from '..';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../../redux/selectors/profile';
import {useIsSmallScreenDevice} from '../../../../../../shared/hooks/useIsSmallScreenDevice';
import {useCustomBackhandler} from '../../../../../../shared/hooks/useCustomBackhandler';
import {useAppDispatch} from '../../../../../../redux';
import {setRuntimeLoginStepState} from '../../../../../../redux/actions/runtime/loginStep';
import {LoginState} from '../../../../../../shared/models/login/loginStep';

export const EsiaRegCardFormMobile = () => {
  const route = useRoute();
  const fromReissue = Boolean((route.params as {fromReissue?: boolean} | undefined)?.fromReissue);
  const readOnly = Boolean((route.params as {readOnly?: boolean} | undefined)?.readOnly);
  useCustomBackhandler(fromReissue);
  const theme = useTheme();
  const isSmallScreen = useIsSmallScreenDevice();
  const dispatch = useAppDispatch();
  const styles = useStyles(() => ({
    safeArea: {
      flex: 1,
    },
    header: {
      ...theme.topBar.header,
      elevation: 6,
      minHeight: 54,
      paddingRight: 10,
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerBackBtn: {
      width: 48,
      height: 48,
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerTitle: {
      paddingRight: 24,
    },
    body: {
      flex: 1,
      paddingHorizontal: 16,
      paddingVertical: 20,
    },
  }));
  const profile = useSelector(holderProfileSelector());
  const navigation = useNavigation();
  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(Screens.Login);
    }
  }, [navigation]);
  const onSubmit = () => {
    dispatch(setRuntimeLoginStepState(LoginState.esiaRegCardDeliveryHandling));
    navigation.navigate(Screens.EsiaRegistrationCardMap);
  };

  return (
    <Screen>
      <SafeAreaView edges={['top']} style={styles.safeArea}>
        {!profile ? (
          <View testID='header-container' style={styles.header}>
            <TouchableOpacity onPress={goBack} style={styles.headerBackBtn} testID='header-content'>
              <images.Left height={24} width={24} color={theme.color.primaryColor} />
            </TouchableOpacity>
            <Text type={isSmallScreen ? 'action' : 'h6'} style={styles.headerTitle}>
              Оформление нефинансовой ЕСК
            </Text>
          </View>
        ) : null}
        <View style={styles.body}>
          <EsiaRegCardFormScreen onEsiaSubmit={onSubmit} readOnly={readOnly} />
        </View>
      </SafeAreaView>
    </Screen>
  );
};
